import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import { SidebarDataStudent } from './SidebarDataStudent';
import SubMenuStudent from './SubMenuStudent';
import { IconContext } from 'react-icons/lib';

const Nav = styled.div`
  background: #20233D;
  font-family: 'Poppins', sans-serif;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const NavIcon = styled(Link)`
  margin-left: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 2rem;
  height: 80px;
  display: flex;
  color: white;
  justify-content: flex-start;
  align-items: center;
`;

const SidebarNav = styled.nav`
  background: white;
  font-family: 'Poppins', sans-serif;
  width: 350px;
  min-height:100vh;
  display: flex;
  justify-content: center;
  position: absolute;
  top: calc(1% + 40px);
  left: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
  transition: 350ms;
  z-index: 10;

`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const SidebarStudent = () => {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <IconContext.Provider value={{ color: '#black' }}>
        <Nav>
          <NavIcon to='#'>
            <FaIcons.FaBars onClick={showSidebar} />
          </NavIcon>
        </Nav>
        <SidebarNav sidebar={sidebar}>
          <SidebarWrap>
            <NavIcon to='#'>
              <AiIcons.AiOutlineClose onClick={showSidebar} />
            </NavIcon>
            {SidebarDataStudent.map((item, index) => {
              return <SubMenuStudent item={item} key={index} />;
            })}
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </>
  );
};

export default SidebarStudent;